import type { VisitTask } from '@/store/visitDetailSlice';
import { TaskCard } from './TaskCard';

interface VisitTasksListProps {
  tasks: VisitTask[];
}

export function VisitTasksList({ tasks }: VisitTasksListProps) {
  return (
    <section className="flex flex-col gap-3">
      <h3 className="text-lg font-semibold text-foreground">Задачи · {tasks.length}</h3>
      {tasks.length === 0 ? (
        <p className="text-sm text-muted">Задачи отсутствуют</p>
      ) : (
        tasks.map((task) => <TaskCard key={task.id} task={task} />)
      )}
    </section>
  );
}
